import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class GalleryMain implements Plugin {
  private currentIndex: number = 0;
  private images: string[] = [];
  private mainImageElement: HTMLImageElement | null = null;
  private prevBtn: HTMLElement | null = null;
  private nextBtn: HTMLElement | null = null;

  constructor(private readonly element: HTMLElement) {
    this.mainImageElement = this.element.querySelector(
      ".com-galleryB2B__first-image .com-imageB2B__image",
    );

    this.prevBtn = this.element.querySelector(".core-carouselNav--left");
    this.nextBtn = this.element.querySelector(".core-carouselNav--right");

    const dataImages = this.element.dataset.images;
    if (dataImages) {
      try {
        this.images = JSON.parse(dataImages);
      } catch (e) {
        console.error("GalleryMain: Erro ao processar imagens", e);
      }
    }
  }

  init(): void {
    if (this.images.length <= 1) return;

    this.prevBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.navigate(-1);
    });

    this.nextBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.navigate(1);
    });

    this.element.addEventListener(
      "click",
      (e) => {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        if (!isMobile) return;

        const target = e.target as HTMLElement;
        const modalTrigger =
          target.closest(".modal-trigger") || target.closest("[data-modal]");

        if (modalTrigger) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      { capture: true },
    );
  }

  private navigate(direction: number): void {
    let newIndex = this.currentIndex + direction;

    if (newIndex < 0) newIndex = this.images.length - 1;
    if (newIndex >= this.images.length) newIndex = 0;

    this.currentIndex = newIndex;
    this.updateImage();
  }

  private updateImage(): void {
    if (this.mainImageElement && this.images[this.currentIndex]) {
      this.mainImageElement.src = this.images[this.currentIndex];
    }
  }
}

PluginRegistry.register("gallery-main", GalleryMain);
